import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Employes from './pages/Employes';
import Acces from './pages/Acces';
import Historique from './pages/Historique';
import Reglages from './pages/Reglages';
import Rapports from './pages/Rapports';
import AnalyseClients from './pages/AnalyseClients';
import Personnalisation from './pages/Personnalisation';
import Communications from './pages/Communications';
import Clients from './pages/Clients';
import CopiloteIA from './pages/CopiloteIA';
import Onboarding from './pages/Onboarding';
import AssistantIA from './components/AssistantIA';
import Integrations from './pages/Integrations';
import DocumentsEmployes from './pages/DocumentsEmployes';
import Etablissement from './pages/Etablissement';
import Restaurant from './pages/Restaurant';
import ReservationPublique from './pages/ReservationPublique';
import { api } from './api';

const API = 'https://qbdp-backend-production.up.railway.app/api';

// ── ÉCRAN COMPTE SUSPENDU ─────────────────────────────────────────────────────
function EcranSuspendu({ onLogout }) {
  const token = sessionStorage.getItem('qbdp_token');
  const API_URL = 'https://qbdp-backend-production.up.railway.app/api';

  const ouvrirPortail = () => {
    fetch(`${API_URL}/stripe-enterprise/portail`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ return_url: window.location.href }),
    })
      .then(r => r.json())
      .then(d => { if (d.url) window.location.href = d.url; })
      .catch(() => alert('Impossible d\'ouvrir le portail de facturation.'));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f5f7' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 48, maxWidth: 480, textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111827', marginBottom: 12 }}>Compte suspendu</h2>
        <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6, marginBottom: 32 }}>
          Votre abonnement a été suspendu. Veuillez régulariser votre situation pour continuer à accéder à votre espace.
        </p>
        <button onClick={ouvrirPortail}
          style={{ width: '100%', padding: '14px 0', background: '#1a56db', color: 'white', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginBottom: 12 }}>
          Gérer mon abonnement →
        </button>
        <button onClick={onLogout}
          style={{ width: '100%', padding: '12px 0', background: 'none', color: '#9ca3af', border: '1px solid #e5e7eb', borderRadius: 12, fontSize: 13, cursor: 'pointer' }}>
          Se déconnecter
        </button>
      </div>
    </div>
  );
}

// ── BANNIÈRE PROGRESSION ONBOARDING ──────────────────────────────────────────
function BanniereOnboarding({ onboarding, onOuvrir }) {
  if (!onboarding || onboarding.onboarding_done) return null;
  if (onboarding.progression === 100) return null;
  return (
    <div style={{ background: '#eff6ff', borderBottom: '1px solid #bfdbfe', padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 16 }}>🚀</span>
        <div>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#1e40af' }}>
            Configuration en cours — {onboarding.done}/{onboarding.total} étapes complétées
          </span>
          <div style={{ marginTop: 4, width: 200, height: 4, background: '#bfdbfe', borderRadius: 4 }}>
            <div style={{ width: `${onboarding.progression}%`, height: '100%', background: '#1a56db', borderRadius: 4, transition: 'width .5s' }} />
          </div>
        </div>
      </div>
      <button onClick={onOuvrir}
        style={{ background: '#1a56db', color: 'white', border: 'none', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
        Reprendre la configuration →
      </button>
    </div>
  );
}

const hexToRgba = (hex, alpha) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0,2), 16);
  const g = parseInt(h.slice(2,4), 16);
  const b = parseInt(h.slice(4,6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

export default function App() {
  const [user, setUser]                     = useState(null);
  const [ready, setReady]                   = useState(false);
  const [page, setPage]                     = useState('/');
  const [filterService, setFilterService]   = useState(null);
  const [employees, setEmployees]           = useState([]);
  const [services, setServices]             = useState([]);
  const [clients, setClients]               = useState([]);
  const [selectedEmploye, setSelectedEmploye] = useState(null);
  const [onboarding, setOnboarding]         = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [abo, setAbo]                       = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem('qbdp_token');
    if (token) {
      fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(u => { if (u.id) setUser(u); })
        .catch(() => {})
        .finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, []);

  const loadBranding = () => {
    const token = sessionStorage.getItem('qbdp_token');
    if (!token) return;
    fetch(`${API}/personnalisation/parametres`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        const c = d.couleur_principale || '#1a56db';
        document.documentElement.style.setProperty('--blue', c);
        document.documentElement.style.setProperty('--blue-light', hexToRgba(c, 0.1));
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (user) {
      api.getEmployes().then(setEmployees).catch(() => {});
      api.getServices().then(setServices).catch(() => {});
      api.getClients().then(setClients).catch(() => {});
      loadBranding();
      const token = sessionStorage.getItem('qbdp_token');

      // Charger statut onboarding
      fetch(`${API}/onboarding/statut`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(d => {
          setOnboarding(d);
          if (!d.onboarding_done && d.onboarding_step === 0) {
            setShowOnboarding(true);
          }
        })
        .catch(() => {});

      // Charger statut abonnement + polling toutes les 5 min pour détecter expiration en cours de session
      const fetchAbo = () => fetch(`${API}/stripe-enterprise/statut`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(setAbo)
        .catch(() => {});
      fetchAbo();
      const aboInterval = setInterval(fetchAbo, 5 * 60 * 1000);
      return () => clearInterval(aboInterval);
    }
  }, [user]);

  const handleLogout = () => {
    sessionStorage.removeItem('qbdp_token');
    sessionStorage.removeItem('qbdp_user');
    setUser(null);
  };

  const handleOnboardingTerminer = (path = null) => {
    setShowOnboarding(false);
    setOnboarding(prev => ({ ...prev, onboarding_done: true }));
    if (path) setPage(path.replace('/', ''));
    api.getEmployes().then(setEmployees).catch(() => {});
    api.getServices().then(setServices).catch(() => {});
    api.getClients().then(setClients).catch(() => {});
  };

  const handleOnboardingPasser = () => {
    setShowOnboarding(false);
    api.getEmployes().then(setEmployees).catch(() => {});
    api.getServices().then(setServices).catch(() => {});
    api.getClients().then(setClients).catch(() => {});
  };

  const refreshOnboarding = () => {
    const token = sessionStorage.getItem('qbdp_token');
    fetch(`${API}/onboarding/statut`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(setOnboarding)
      .catch(() => {});
  };

  // Retour depuis Stripe après paiement — vérifie directement via API Stripe
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('abonnement') === 'annule') {
      window.history.replaceState({}, '', '/');
      // Rediriger vers Réglages > Abonnement pour qu'il puisse réessayer
      setTimeout(() => {
        document.getElementById('tab-abonnement')?.click();
      }, 300);
    }
    if (params.get('abonnement') === 'succes' && user) {
      const token     = sessionStorage.getItem('qbdp_token');
      const sessionId = params.get('session_id') || '';
      window.history.replaceState({}, '', '/');
      fetch(`${API}/stripe-enterprise/verify-checkout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId }),
      })
        .then(r => r.json())
        .then(setAbo)
        .finally(() => refreshOnboarding());
    }
  }, [user]);

  // Page publique restaurant — accessible sans authentification
  const publicSlug = (() => {
    const path = window.location.pathname;
    const m = path.match(/^\/r\/([a-z0-9-]+)$/);
    return m ? m[1] : null;
  })();
  if (publicSlug) return <ReservationPublique slug={publicSlug} />;

  if (!ready) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f5f7' }}>
      <div style={{ fontSize: 13, color: '#6b7280' }}>Chargement...</div>
    </div>
  );

  const Login = require('./pages/Login').default;
  if (!user) return <Login onLogin={u => {
    setUser(u);
    sessionStorage.setItem('qbdp_user', JSON.stringify(u));
    window.history.replaceState({}, '', '/');
  }} />;

  // Compte suspendu ou résilié — bloquer l'accès
  if (abo && ['suspendu', 'annule'].includes(abo.statut) && user?.role !== 'super_admin') {
    return <EcranSuspendu onLogout={handleLogout} />;
  }

  // Afficher le wizard
  if (showOnboarding) return (
    <Onboarding
      user={user}
      onTerminer={handleOnboardingTerminer}
      onPasser={onboarding?.onboarding_step === 0 ? null : handleOnboardingPasser}
    />
  );

  const pages = {
    '/':                 <Dashboard />,
    '/employes':         <Employes filterService={filterService} employees={employees} setEmployees={setEmployees} services={services} onGererAcces={(emp) => { setSelectedEmploye(emp); setPage('/acces'); }} />,
    '/acces':            <Acces selectedEmploye={selectedEmploye} onClearSelectedEmploye={() => setSelectedEmploye(null)} />,
    '/historique':       <Historique />,
    '/rapports':         <Rapports />,
    '/analyse-clients':  <AnalyseClients />,
    '/etablissement':    <Etablissement />,
    '/restaurant':       <Restaurant />,
    '/reglages':         <Reglages />,
    '/personnalisation': <Personnalisation />,
    '/communications':   <Communications />,
    '/clients':          <Clients clients={clients} setClients={setClients} onGererAcces={(client) => { setSelectedEmploye({...client, _type: 'client'}); setPage('/acces'); }} />,
    '/copilote-ia':      <CopiloteIA onNavigate={p => setPage(p)} />,
    '/integrations':     <Integrations />,
    '/documents-employes': <DocumentsEmployes />,
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <Sidebar
        active={page}
        onNavigate={p => { if (page === '/personnalisation') loadBranding(); setPage(p); refreshOnboarding(); }}
        onLogout={handleLogout}
        user={user}
        onFilterService={setFilterService}
        employees={employees}
        services={services}
        clients={clients}
      />
      <div style={{ marginLeft: '220px', flex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <BanniereOnboarding onboarding={onboarding} onOuvrir={() => setShowOnboarding(true)} />
        <main style={{ flex: 1, background: '#f4f5f7' }}>
          {pages[page] || pages['/']}
        </main>
      </div>
      <AssistantIA currentPage={page} onNavigate={p => { setPage(p); refreshOnboarding(); }} />
    </div>
  );
}
